import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import PropertyDetail from "./pages/PropertyDetail";
import Cards from "./pages/Cards";

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        {/* A raiz mostrava uma pagina em branco: sem id, o PropertyDetail nao
            tem o que renderizar. Agora ela e a pagina de cards de divulgacao.
            Precisa vir ANTES da rota curinga /:id?, senao o Switch casa
            primeiro nela e tenta abrir um imovel de id vazio. */}
        <Route path="/" exact component={Cards} />
        <Route path="/:id?" exact component={PropertyDetail} />
      </Switch>
    </BrowserRouter>
  );
}
